export default __webpack_public_path__ + "images/handyman.bb971b226efa9297f98c53c477741a2b.svg";